/**
 * Harte Navigation — die ganze Seite neu laden, statt im SPA umzuschalten.
 *
 * Eigene Datei, damit der Aufruf im Test austauschbar ist: `window.location`
 * laesst sich in jsdom nicht sauber ueberwachen, ein Modul schon.
 */
export function ganzeSeiteZu(pfad: string): void {
  // `replace` statt `assign`: der abgemeldete Zustand gehoert nicht in die
  // Zurueck-Liste des Browsers.
  window.location.replace(pfad)
}
